// Urgent (safety) escalations, shared by the API and the Admin Hub.
//
// When the nurse chat bot escalates a patient-safety or nurse-safety situation
// (an injury or needle stick, a 911 call or ER trip, a patient in danger,
// suicide risk, abuse or neglect) it labels the ticket's `escalated_reason`
// with this prefix. The API emails the team the moment it is set
// (`services/escalation-alert.service.ts`) and the Admin Hub shows an Urgent
// badge on the ticket from it. A label in the reason rather than a new column:
// every staff view that lists escalations already carries the reason, and
// nothing needs to query on it. In the Sep 2026 audit, 8 of 12 safety
// escalations were never answered.
/** Prefix on `tickets.escalated_reason` that marks a safety escalation. */
export const URGENT_ESCALATION_PREFIX = "URGENT (safety): ";
/** True when an escalation reason carries the urgent (safety) label. */
export function isUrgentEscalation(reason) {
    return typeof reason === "string" && reason.startsWith(URGENT_ESCALATION_PREFIX);
}
/** The reason with the urgent label in front, added once. */
export function markUrgentEscalationReason(reason) {
    return isUrgentEscalation(reason) ? reason : `${URGENT_ESCALATION_PREFIX}${reason}`;
}
//# sourceMappingURL=escalation.js.map